import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { nautilusGetRequest } from "network";
import { iplLabelTypeKeys, iplLabelKeys } from "reactQuery/keys";

import { IPLLabelType, IPLLabel } from "./apiTypes";

export const useGetIplLabelTypes = ({
    enabled = true,
}: {
    enabled: boolean;
}): UseQueryResult<IPLLabelType[]> => {
    const queryKey = iplLabelTypeKeys.all();
    return useQuery({
        queryKey,
        queryFn: async (): Promise<IPLLabelType[]> =>
            (await nautilusGetRequest("/api/target_reports/ipl_label_types/")).data,
        enabled,
    });
};

export const useGetIplLabels = ({
    labelTypes = null,
    enabled,
}: {
    labelTypes?: number;
    enabled: boolean;
}): UseQueryResult<IPLLabel[]> => {
    const queryKey = iplLabelKeys.labelTypes(labelTypes);

    const params = labelTypes ? `?label_types=${labelTypes}` : "";

    return useQuery({
        queryKey,
        queryFn: async (): Promise<IPLLabel[]> =>
            (await nautilusGetRequest(`/api/target_reports/ipl_labels/`, params)).data,
        enabled,
    });
};
